import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Table } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Bar, Pie } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement);

const paymentData = {
  totalPayments: 12000,
  lastMonthPayment: 1000,
  last12Months: [500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1000],
  teamPayments: 7000,
  proPlanPayments: 5000,
  teamPaymentsMonthly: [200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750], 
  proPaymentsMonthly: [300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850], 
  detailedPayments: [
    { date: '2025-01-05', amount: 450, type: 'Team' },
    { date: '2025-01-10', amount: 600, type: 'Pro' },
    { date: '2025-01-15', amount: 500, type: 'Team' },
    { date: '2025-01-20', amount: 700, type: 'Pro' },
    { date: '2025-01-25', amount: 800, type: 'Team' },
    { date: '2025-02-01', amount: 900, type: 'Pro' },
    { date: '2025-02-05', amount: 1000, type: 'Team' },
    { date: '2025-02-10', amount: 1100, type: 'Pro' },
    { date: '2025-02-15', amount: 950, type: 'Team' },
    { date: '2025-02-20', amount: 1150, type: 'Pro' },
    { date: '2025-02-25', amount: 1200, type: 'Team' },
    { date: '2025-03-01', amount: 1300, type: 'Pro' },
    { date: '2025-03-05', amount: 1400, type: 'Team' },
    { date: '2025-03-10', amount: 1500, type: 'Pro' },
    { date: '2025-03-15', amount: 1350, type: 'Team' },
    { date: '2025-03-20', amount: 1450, type: 'Pro' },
    { date: '2025-03-25', amount: 1600, type: 'Team' },
    { date: '2025-04-01', amount: 1700, type: 'Pro' },
    { date: '2025-04-05', amount: 1750, type: 'Team' },
    { date: '2025-04-10', amount: 1800, type: 'Pro' }
  ],
};

function PaymentDashboard() {
  const [filter, setFilter] = useState('all');

  const filteredPayments = paymentData.detailedPayments.filter((payment) =>
    filter === 'all' ? true : payment.type.toLowerCase() === filter
  );

  const filteredBarData =
    filter === 'all'
      ? paymentData.last12Months
      : filter === 'team'
      ? paymentData.teamPaymentsMonthly
      : paymentData.proPaymentsMonthly;

  const barChartData = {
    labels: ['Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb'],
    datasets: [
      {
        label: filter === 'all' ? 'Monthly Payments' : filter === 'team' ? 'Team Payments' : 'Pro Plan Payments',
        data: filteredBarData,
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  };

  const barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'top' },
      title: { display: true, text: filter === 'all' ? 'Last 12 Months Payments' : `Last 12 Months ${filter.charAt(0).toUpperCase() + filter.slice(1)} Payments` },
    },
  };

  const pieChartData = {
    labels: ['Team Payments', 'Pro Plan Payments'],
    datasets: [
      {
        data: [paymentData.teamPayments, paymentData.proPlanPayments],
        backgroundColor: ['rgba(255, 99, 132, 0.6)', 'rgba(54, 162, 235, 0.6)'],
        borderColor: ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)'],
        borderWidth: 1,
      },
    ],
  };

  return (
    <Container fluid className="p-4 rounded-3" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', marginTop:"5vh" }}>
      <h2 className='mb-3'>Revenue Section</h2>
      <Row className="mb-4 g-4">
        <Col md={3}>
          <Card className="text-center h-100 shadow-sm">
            <Card.Body>
              <Card.Title className="text-secondary">Total Payments</Card.Title>
              <Card.Text className="fs-3 text-dark">${paymentData.totalPayments}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center h-100 shadow-sm">
            <Card.Body>
              <Card.Title className="text-secondary">Last Month</Card.Title>
              <Card.Text className="fs-3 text-dark">${paymentData.lastMonthPayment}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center h-100 shadow-sm">
            <Card.Body>
              <Card.Title className="text-secondary">Team Payments</Card.Title>
              <Card.Text className="fs-3 text-dark">${paymentData.teamPayments}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center h-100 shadow-sm">
            <Card.Body>
              <Card.Title className="text-secondary">Pro Plan Payments</Card.Title>
              <Card.Text className="fs-3 text-dark">${paymentData.proPlanPayments}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={4}>
          <Form.Select value={filter} onChange={(e) => setFilter(e.target.value)} className="shadow-sm">
            <option value="all">All Payments</option>
            <option value="team">Team Payments</option>
            <option value="pro">Pro Plan Payments</option>
          </Form.Select>
        </Col>
      </Row>

      <Row className="mb-4 g-4">
        <Col md={6}>
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <div style={{ height: '400px' }}>
                <Bar data={barChartData} options={barOptions} />
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <div style={{ height: '400px' }}>
                <Pie data={pieChartData} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card className="shadow-sm">
            <Card.Body>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Type</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPayments.map((payment, index) => (
                    <tr key={index}>
                      <td>{payment.date}</td>
                      <td>${payment.amount}</td>
                      <td>{payment.type}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default PaymentDashboard;
